// removed by extract-text-webpack-plugin
module.exports = {"icon":"_2Divhfk09ieT5Ie59P6k2k"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/DatePicker/DatePickerInput.scss
// module id = ./node_modules/wix-style-react/dist/es/src/DatePicker/DatePickerInput.scss
// module chunks = 0